var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Col, Select } from '@folio/stripes/components';
import React from 'react';
import { Field } from 'react-final-form';
import { FormattedMessage, useIntl } from 'react-intl';
export default function FeeFineTypeToken(_a) {
    var prefix = _a.prefix;
    var intl = useIntl();
    return (React.createElement(Col, { xs: 12 },
        React.createElement(Field, { name: "".concat(prefix, "feeFineAttribute"), defaultValue: "FEE_FINE_TYPE_NAME" }, function (fieldProps) { return (React.createElement(Select, __assign({}, fieldProps, { required: true, marginBottom0: true, label: React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.token.feeFineType.attribute" }), dataOptions: [
                {
                    label: intl.formatMessage({
                        id: 'ui-plugin-bursar-export.bursarExports.token.feeFineType.name',
                    }),
                    value: 'FEE_FINE_TYPE_NAME',
                },
                {
                    label: intl.formatMessage({
                        id: 'ui-plugin-bursar-export.bursarExports.token.feeFineType.id',
                    }),
                    value: 'FEE_FINE_TYPE_ID',
                },
            ] }))); })));
}
